import Badge from "ds/components/Badge";
import { BadgeVariants } from "ds/components/Badge/types";
import { ScanRunState } from "types/generated";

type ScanRunStateConfig = {
  variant: BadgeVariants;
  text: string;
};

const SCAN_RUN_STATES: Record<ScanRunState, ScanRunStateConfig> = {
  [ScanRunState.Queued]: { variant: "gray", text: "Queued" },
  [ScanRunState.Scanning]: { variant: "blue", text: "Scanning" },
  [ScanRunState.Finished]: { variant: "green", text: "Finished" },
  [ScanRunState.Failed]: { variant: "red", text: "Failed" },
  [ScanRunState.Canceled]: { variant: "gray", text: "Canceled" },
  [ScanRunState.Stopped]: { variant: "gray", text: "Stopped" },
};

type ScanRunStateBadgeProps = {
  state: ScanRunState;
};

const ScanRunStateBadge = ({ state }: ScanRunStateBadgeProps) => {
  const config = SCAN_RUN_STATES[state];

  if (!config) {
    return null;
  }

  return <Badge variant={config.variant} type="strong" text={config.text} />;
};

export default ScanRunStateBadge;
